import React, { useEffect, useMemo, useState } from 'react'
import styles from './PreMedicos.module.css'
import Head from '../Helper/Head'
import TituloAssociado from '../Helper/TituloAssociado'
import { Link, useFetcher } from 'react-router-dom'
import { useMedicoContext } from '../../useMedicoContext'
import { useUserContext } from '../../UserContext'
import { GET_ASSOCIADOS, GET_MEDICOS_PRE } from '../../api'

const PreMedicos = () => {
  const { setMedico, medicos = [], setMedicos, setFormData } = useMedicoContext();
  const { loading, setLoading, tokenGer } = useUserContext();
  const [pesquisar, setPesquisar] = useState('');
  const [pesquisando, setPesquisando] = useState(false)
  const [pesquisados, setPesquisados] = useState([])
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'ascending' });


  function definirMedico(id: any): React.MouseEventHandler<HTMLAnchorElement> {
    return (event): void => {
      setMedico(medicos.filter((item: any) => item.id_medico === id));
    };
  }

  function handleChange({ target }: any) {
    setPesquisar(target.value.toUpperCase())
  }

  useEffect(() => {
    if (pesquisar && pesquisar.length > 2) {
      setPesquisando(true);
      setPesquisados(medicos.filter((medico: any) => {
        if ((medico.nom_fantasia && medico.nom_fantasia.includes(pesquisar)) || medico.num_cnpj.includes(pesquisar) || medico.nom_medico.includes(pesquisar) || medico.num_crm.includes(pesquisar))
          return medico;
      }))
      // setPesquisados(pesquisados)
    } else {
      setPesquisando(false)
      setPesquisados([]);
    }

  }, [pesquisar])

  useEffect(() => {
    async function buscarMedicos() {
      try {
        setLoading(true)
        const { url, options } = GET_MEDICOS_PRE(tokenGer);
        const response = await fetch(url, options);
        const data = await response.json();
        if (!response.ok) throw new Error(data.message);
        setMedicos(data);
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false);
      }
    }
    setMedico({})
    buscarMedicos();
    setFormData(undefined)
  }, [])

  const sortedMedicos = useMemo(() => {
    return [...medicos].sort((a, b) => {
      if (sortConfig.key) {
        let aValue = a[sortConfig.key] || '';
        let bValue = b[sortConfig.key] || '';
        if (sortConfig.key === 'nom_fantasia' || sortConfig.key === 'nom_clinica') {
          aValue = aValue.toUpperCase();
          bValue = bValue.toUpperCase();
        }
        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }
      return 0;
    });
  }, [medicos, sortConfig]);


  function requestSort(key: string) {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  }

  return (
    <section className={`${styles.containerMain} animeLeft`}>
      <Head
        title="Área Gerencial - Associados"
        description="Área gerencial"
      />
      <TituloAssociado titulo='Pré cadastro - profissionais' />
      <input className={styles.procurar} type="text" placeholder='Pesquisar médico' onChange={handleChange} value={pesquisar} />
      <div className={styles.divCorpoClinico}>
        <table className={styles.table}>
          <tr>
            <th onClick={() => requestSort('nom_medico')}>Nome</th>
            <th onClick={() => requestSort('num_crm')}>Conselho</th>
            <th onClick={() => requestSort('nom_fantasia')}>Clínica</th>
            <th onClick={() => requestSort('num_cnpj')}>CNPJ - Empresa</th>
          </tr>

          {pesquisando ? pesquisados && pesquisados.map((item: any, index: any) => (
            <>
              <Link key={index} to={item.nom_medico} onClick={definirMedico(item.id_medico)}>
                <tr>
                  <td className={styles.td}>{item.nom_medico}</td>
                  <td className={styles.td}>{item.num_crm}</td>
                  <td className={styles.td}>{item.nom_fantasia}</td>
                  <td className={styles.td}>{item.num_cnpj}</td>
                </tr>
              </Link>
              <span className={styles.sep}></span>
            </>

          )) : sortedMedicos && sortedMedicos.length !== 0 ? sortedMedicos.map((item: any, index: any) => (
            <>
              <Link key={index} to={item.nom_medico} onClick={definirMedico(item.id_medico)}>
                <tr>
                  <td className={styles.td}>{item.nom_medico}</td>
                  <td className={styles.td}>{item.num_crm}</td>
                  <td className={styles.td}>{item.nom_clinica}</td>
                  <td className={styles.td}>{item.num_cnpj}</td>
                </tr>
              </Link>
              <span className={styles.sep}></span>
            </>
          ))
            :
            <tr>
              <td colSpan={4} className={`${styles.nenhum} spanAll`}>Nenhuma clínica aguardando aprovação de cadastro</td>
            </tr>
          }

        </table>
      </div>
    </section>
  )
}

export default PreMedicos